import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_plus_in_circle.svg';
import Icon, { IconProps } from './icon';

const IconPlusInCircle = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconPlusInCircle;
